/* =========================================================
   GLP BLUEPRINT - Landing Page JS (Shopify Theme)
   ========================================================= */

(function () {
  'use strict';

  // ---------- CONFIG injected from Liquid via window.GLP_CONFIG ----------
  // Fields:
  //   storefrontDomain, storefrontToken, apiVersion
  //   blueprintVariantId, plannerVariantId, homeEnvVariantId
  //   discountCode, newsletterDelayMs, urls: {checkout, thankyou, upsell, home}
  var CFG = window.GLP_CONFIG || {};

  // ---------- TOAST ----------
  var toastContainer;
  function ensureToast() {
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.className = 'toast-container';
      document.body.appendChild(toastContainer);
    }
  }
  function toast(title, desc, variant) {
    ensureToast();
    var t = document.createElement('div');
    t.className = 'toast' + (variant === 'destructive' ? ' is-destructive' : '');
    var html = '';
    if (title) html += '<strong>' + escapeHtml(title) + '</strong>';
    if (desc) html += '<p>' + escapeHtml(desc) + '</p>';
    t.innerHTML = html;
    toastContainer.appendChild(t);
    setTimeout(function () {
      t.classList.add('is-removing');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 4500);
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- SHOPIFY STOREFRONT API ----------
  function storefrontUrl() {
    return 'https://' + CFG.storefrontDomain + '/api/' + (CFG.apiVersion || '2025-07') + '/graphql.json';
  }

  function storefrontRequest(query, variables) {
    return fetch(storefrontUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.storefrontToken
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (data) {
      if (data.errors) throw new Error('Shopify error: ' + data.errors.map(function (e) { return e.message; }).join(', '));
      return data;
    });
  }

  var CART_CREATE_MUTATION = "mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } } }";
  var CART_DISCOUNT_MUTATION = "mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) { cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) { cart { id } userErrors { field message } } }";
  var CUSTOMER_CREATE_MUTATION = "mutation customerCreate($input: CustomerCreateInput!) { customerCreate(input: $input) { customer { id email } customerUserErrors { code field message } } }";

  function formatCheckoutUrl(u) {
    try {
      var url = new URL(u);
      url.searchParams.set('channel', 'online_store');
      return url.toString();
    } catch (e) { return u; }
  }

  function createShopifyCart(items, discountCode) {
    var lines = items.map(function (i) { return { quantity: i.quantity, merchandiseId: i.variantId }; });
    return storefrontRequest(CART_CREATE_MUTATION, { input: { lines: lines } }).then(function (data) {
      var c = data && data.data && data.data.cartCreate;
      if (!c || (c.userErrors && c.userErrors.length)) {
        console.error('Cart creation failed:', c && c.userErrors);
        return null;
      }
      var cart = c.cart;
      if (!cart || !cart.checkoutUrl) return null;
      var result = { cartId: cart.id, checkoutUrl: formatCheckoutUrl(cart.checkoutUrl) };
      if (discountCode) {
        return storefrontRequest(CART_DISCOUNT_MUTATION, { cartId: cart.id, discountCodes: [discountCode] })
          .catch(function (e) { console.warn('Discount code failed:', e); })
          .then(function () { return result; });
      }
      return result;
    });
  }

  /**
   * Navigate to the Shopify checkout URL — SAME-TAB MODE.
   * Il checkout sostituisce la landing page nella stessa scheda del browser.
   * Il parametro `prewin` viene ignorato (mantenuto per compatibilità di firma).
   */
  function goToCheckout(checkoutUrl, prewin) {
    if (!checkoutUrl) return;
    // Se per qualunque motivo è stata pre-aperta una tab, la chiudiamo subito.
    if (prewin && !prewin.closed) {
      try { prewin.close(); } catch (e) {}
    }
    // Navigazione same-tab
    window.location.href = checkoutUrl;
  }

  function createNewsletterSubscriber(email) {
    var randomPassword = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : (Math.random().toString(36).slice(2) + Date.now())) + '!Aa1';
    return storefrontRequest(CUSTOMER_CREATE_MUTATION, {
      input: { email: email, password: randomPassword, acceptsMarketing: true }
    }).then(function (data) {
      var errors = data && data.data && data.data.customerCreate && data.data.customerCreate.customerUserErrors;
      if (errors && errors.length) {
        if (errors.some(function (e) { return e.code === 'TAKEN'; })) return true;
        console.error('Customer creation errors:', errors);
        return false;
      }
      return true;
    }).catch(function (err) {
      console.error('Newsletter failed:', err);
      return false;
    });
  }

  // ---------- DIALOG (modal) ----------
  function openDialog(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDialog(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function bindDialogs() {
    document.querySelectorAll('.dialog-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeDialog(overlay.id);
      });
      overlay.querySelectorAll('[data-dialog-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeDialog(overlay.id); });
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dialog-overlay.is-open').forEach(function (o) { closeDialog(o.id); });
      }
    });
  }

  // ---------- NEWSLETTER POPUP ----------
  function initNewsletter() {
    var popup = document.getElementById('newsletter-dialog');
    if (!popup) return;
    var DISMISSED_KEY = 'newsletter_popup_dismissed';
    if (!sessionStorage.getItem(DISMISSED_KEY)) {
      setTimeout(function () { openDialog('newsletter-dialog'); }, CFG.newsletterDelayMs || 4000);
    }
    // mark as dismissed on close
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('[data-dialog-close]')) {
        sessionStorage.setItem(DISMISSED_KEY, 'true');
      }
    });

    var form = document.getElementById('newsletter-form');
    if (!form) return;
    var emailInput = form.querySelector('input[type=email]');
    var consentInput = form.querySelector('input[type=checkbox]');
    var submitBtn = form.querySelector('button[type=submit]');
    var btnLabel = submitBtn.querySelector('.btn-label');
    var btnSpinner = submitBtn.querySelector('.spinner');

    function updateBtnState() {
      submitBtn.disabled = !(emailInput.value && consentInput.checked);
    }
    emailInput.addEventListener('input', updateBtnState);
    consentInput.addEventListener('change', updateBtnState);
    updateBtnState();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!emailInput.value || !consentInput.checked) return;
      submitBtn.disabled = true;
      if (btnLabel) btnLabel.style.display = 'none';
      if (btnSpinner) btnSpinner.style.display = 'inline-block';
      createNewsletterSubscriber(emailInput.value).then(function (ok) {
        if (btnLabel) btnLabel.style.display = '';
        if (btnSpinner) btnSpinner.style.display = 'none';
        if (ok) {
          localStorage.setItem('newsletter_discount', 'true');
          toast("You're in! 🎉", "Check your inbox for your 10% discount code.");
        } else {
          toast('Something went wrong', 'Please try again later.', 'destructive');
        }
        sessionStorage.setItem(DISMISSED_KEY, 'true');
        emailInput.value = ''; consentInput.checked = false; updateBtnState();
        closeDialog('newsletter-dialog');
      });
    });
  }

  // ---------- UPSELL POPUP ----------
  function initUpsellPopup() {
    var popup = document.getElementById('upsell-dialog');
    if (!popup) return;
    var hasDiscount = localStorage.getItem('newsletter_discount') === 'true';
    var BLUEPRINT_PRICE = 39.95;
    var PLAY_PRICE = 14.97;
    var dBlueprint = hasDiscount ? +(BLUEPRINT_PRICE * 0.9).toFixed(2) : BLUEPRINT_PRICE;
    var dPlay = hasDiscount ? +(PLAY_PRICE * 0.9).toFixed(2) : PLAY_PRICE;
    var total = +(dBlueprint + dPlay).toFixed(2);
    var discountCode = hasDiscount ? (CFG.discountCode || 'WELCOME10') : null;

    // Apply prices to DOM
    function setText(sel, val) {
      popup.querySelectorAll(sel).forEach(function (el) { el.textContent = val; });
    }
    setText('[data-bp-price]', '$' + dBlueprint.toFixed(2));
    setText('[data-pp-price]', '$' + dPlay.toFixed(2));
    setText('[data-pp-savings]', '$' + (29.95 - dPlay).toFixed(2));
    setText('[data-total]', '$' + total.toFixed(2));
    setText('[data-decline-price]', '$' + dBlueprint.toFixed(2));

    // Discount banner toggle
    var banner = popup.querySelector('[data-discount-banner]');
    if (banner) banner.style.display = hasDiscount ? '' : 'none';

    // Buttons
    var acceptBtn = popup.querySelector('[data-upsell-accept]');
    var declineBtn = popup.querySelector('[data-upsell-decline]');
    var allBtns = [acceptBtn, declineBtn].filter(Boolean);

    function setLoading(loading) {
      allBtns.forEach(function (b) { if (b) b.disabled = loading; });
      if (acceptBtn) {
        var label = acceptBtn.querySelector('.btn-label');
        var loadEl = acceptBtn.querySelector('.btn-loading');
        if (label) label.style.display = loading ? 'none' : '';
        if (loadEl) loadEl.style.display = loading ? '' : 'none';
      }
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        // Same-tab: nessuna tab pre-aperta, il checkout sostituisce la pagina corrente.
        setLoading(true);
        createShopifyCart([
          { variantId: CFG.blueprintVariantId, quantity: 1 },
          { variantId: CFG.plannerVariantId, quantity: 1 }
        ], discountCode).then(function (r) {
          if (r && r.checkoutUrl) {
            goToCheckout(r.checkoutUrl);
            closeDialog('upsell-dialog');
          } else {
            setLoading(false);
            toast('Error creating checkout. Please try again.', null, 'destructive');
          }
        }).catch(function (e) {
          setLoading(false);
          console.error(e);
          toast('Error creating checkout. Please try again.', null, 'destructive');
        });
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        setLoading(true);
        createShopifyCart([
          { variantId: CFG.blueprintVariantId, quantity: 1 }
        ], discountCode).then(function (r) {
          if (r && r.checkoutUrl) {
            goToCheckout(r.checkoutUrl);
            closeDialog('upsell-dialog');
          } else {
            setLoading(false);
            toast('Error creating checkout. Please try again.', null, 'destructive');
          }
        }).catch(function (e) {
          setLoading(false);
          console.error(e);
          toast('Error creating checkout. Please try again.', null, 'destructive');
        });
      });
    }

    // Hook all "openUpsell" triggers
    document.querySelectorAll('[data-open-upsell]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDialog('upsell-dialog');
      });
    });
  }

  // ---------- POST-PURCHASE POPUP ----------
  function initPostPurchase() {
    var popup = document.getElementById('postpurchase-dialog');
    if (!popup) return;
    var acceptBtn = popup.querySelector('[data-postpurchase-accept]');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        var label = acceptBtn.querySelector('.btn-label');
        var loading = acceptBtn.querySelector('.btn-loading');
        acceptBtn.disabled = true;
        if (label) label.style.display = 'none';
        if (loading) loading.style.display = '';
        createShopifyCart([
          { variantId: CFG.homeEnvVariantId, quantity: 1 }
        ]).then(function (r) {
          if (r && r.checkoutUrl) {
            goToCheckout(r.checkoutUrl);
            closeDialog('postpurchase-dialog');
          } else {
            acceptBtn.disabled = false;
            if (label) label.style.display = '';
            if (loading) loading.style.display = 'none';
            toast('Error creating checkout. Please try again.', null, 'destructive');
          }
        }).catch(function (e) {
          acceptBtn.disabled = false;
          if (label) label.style.display = '';
          if (loading) loading.style.display = 'none';
          console.error(e);
          toast('Error creating checkout. Please try again.', null, 'destructive');
        });
      });
    }
  }

  // ---------- UPSELL PAGE (full page version) ----------
  function initUpsellPage() {
    var root = document.querySelector('.upsell-page');
    if (!root) return;
    var hasDiscount = localStorage.getItem('newsletter_discount') === 'true';
    var BLUEPRINT_PRICE = 39.95;
    var PLAY_PRICE = 14.97;
    var dBlueprint = hasDiscount ? +(BLUEPRINT_PRICE * 0.9).toFixed(2) : BLUEPRINT_PRICE;
    var dPlay = hasDiscount ? +(PLAY_PRICE * 0.9).toFixed(2) : PLAY_PRICE;
    var total = +(dBlueprint + dPlay).toFixed(2);
    var discountCode = hasDiscount ? (CFG.discountCode || 'WELCOME10') : null;

    function setText(sel, val) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = val; });
    }
    setText('[data-bp-price]', '$' + dBlueprint.toFixed(2));
    setText('[data-pp-price]', '$' + dPlay.toFixed(2));
    setText('[data-total]', '$' + total.toFixed(2));

    var banner = root.querySelector('[data-discount-banner]');
    if (banner) banner.style.display = hasDiscount ? '' : 'none';

    var acceptBtn = root.querySelector('[data-upsell-accept]');
    var declineBtn = root.querySelector('[data-upsell-decline]');

    function setLoading(loading) {
      [acceptBtn, declineBtn].forEach(function (b) { if (b) b.disabled = loading; });
      if (acceptBtn) {
        var l = acceptBtn.querySelector('.btn-label');
        var ld = acceptBtn.querySelector('.btn-loading');
        if (l) l.style.display = loading ? 'none' : '';
        if (ld) ld.style.display = loading ? '' : 'none';
      }
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        setLoading(true);
        createShopifyCart([
          { variantId: CFG.blueprintVariantId, quantity: 1 },
          { variantId: CFG.plannerVariantId, quantity: 1 }
        ], discountCode).then(function (r) {
          if (r && r.checkoutUrl) goToCheckout(r.checkoutUrl);
          else { setLoading(false); toast('Error creating checkout. Please try again.', null, 'destructive'); }
        }).catch(function (e) { setLoading(false); console.error(e); toast('Error creating checkout. Please try again.', null, 'destructive'); });
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        setLoading(true);
        createShopifyCart([
          { variantId: CFG.blueprintVariantId, quantity: 1 }
        ], discountCode).then(function (r) {
          if (r && r.checkoutUrl) goToCheckout(r.checkoutUrl);
          else { setLoading(false); toast('Error creating checkout. Please try again.', null, 'destructive'); }
        }).catch(function (e) { setLoading(false); console.error(e); toast('Error creating checkout. Please try again.', null, 'destructive'); });
      });
    }
  }

  // ---------- FAQ ACCORDION ----------
  function initFaq() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var trigger = item.querySelector('.faq-trigger');
      var content = item.querySelector('.faq-content');
      if (!trigger || !content) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        // close all siblings (single mode)
        item.parentNode.querySelectorAll('.faq-item').forEach(function (sib) {
          if (sib !== item) {
            sib.setAttribute('data-open', 'false');
            var c = sib.querySelector('.faq-content');
            if (c) c.style.maxHeight = '0';
          }
        });
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
        content.style.maxHeight = isOpen ? '0' : (content.scrollHeight + 'px');
      });
    });
  }

  // ---------- SCROLL ANIMATIONS ----------
  // Reveal on intersection: equivalent to once-only useInView with margin -100px.
  // Per-element delay (data-fx-delay) is applied as CSS transition-delay so the
  // motion curve stays identical instead of being shifted
  // by an extra setTimeout outside the transition.
  function initScrollFx() {
    var nodes = document.querySelectorAll('[data-fx]');
    if (!nodes.length) return;

    // Pre-apply transition-delay from data-fx-delay so the curve stays consistent.
    nodes.forEach(function (el) {
      var d = parseFloat(el.getAttribute('data-fx-delay') || '0');
      if (d > 0) el.style.transitionDelay = d + 's';
      // Stagger: pre-compute children delays so the staggerChildren timing matches.
      if (el.getAttribute('data-fx') === 'stagger') {
        var stagger = parseFloat(el.getAttribute('data-stagger') || '0.1');
        var base = d > 0 ? d : 0;
        var kids = el.children;
        for (var i = 0; i < kids.length; i++) {
          kids[i].style.transitionDelay = (base + stagger * i) + 's';
        }
      }
    });

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('fx-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('fx-visible');
          observer.unobserve(e.target);
        }
      });
    }, {
      // `margin: "-100px"` shrinks the viewport intersection box by 100px on every side.
      threshold: 0,
      rootMargin: '-100px 0px -100px 0px'
    });
    nodes.forEach(function (el) { observer.observe(el); });
  }

  // ---------- NEURAL NETWORK ANIMATION ----------
  function initNeuralNetwork(canvas) {
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var particles = [];
    var mouse = { x: 0, y: 0, active: false };
    var rafId;

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      initParticles();
    }
    function initParticles() {
      particles = [];
      var count = 40;
      var cx = canvas.width / 2;
      var cy = canvas.height / 2;
      for (var i = 0; i < count; i++) {
        var angle = Math.random() * Math.PI * 2;
        var rx = (Math.random() * 0.7 + 0.3) * canvas.width * 0.5;
        var ry = (Math.random() * 0.7 + 0.3) * canvas.height * 0.48;
        particles.push({
          x: cx + Math.cos(angle) * rx,
          y: cy + Math.sin(angle) * ry,
          vx: (Math.random() - 0.5) * 0.8,
          vy: (Math.random() - 0.5) * 0.8,
          radius: Math.random() * 1.5 + 1
        });
      }
    }
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var time = Date.now() * 0.003;
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        var px = Math.sin(time + i * 0.2) * 0.8;
        var py = Math.cos(time + i * 0.2) * 0.8;
        p.vx += px * 0.04; p.vy += py * 0.04;
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        if (mouse.active) {
          var dx = mouse.x - p.x;
          var dy = mouse.y - p.y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            var f = (120 - dist) / 120;
            p.vx += (dx / dist) * f * 0.02;
            p.vy += (dy / dist) * f * 0.02;
          }
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius * 1.3, 0, Math.PI * 2);
        ctx.fillStyle = 'hsla(0,0%,100%,0.85)';
        ctx.shadowBlur = 8;
        ctx.shadowColor = 'hsla(0,0%,100%,0.5)';
        ctx.fill();
        ctx.shadowBlur = 0;
        for (var j = i + 1; j < particles.length; j++) {
          var q = particles[j];
          var ddx = q.x - p.x, ddy = q.y - p.y;
          var dd = Math.sqrt(ddx * ddx + ddy * ddy);
          if (dd < 150) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.strokeStyle = 'hsla(0,0%,100%,' + (0.45 * (1 - dd / 150)) + ')';
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        }
        p.vx *= 0.99; p.vy *= 0.99;
      }
      rafId = requestAnimationFrame(animate);
    }
    resize();
    window.addEventListener('resize', resize);
    animate();
  }

  // ---------- VIDEO AUTOPLAY ON SCROLL ----------
  function initVideos() {
    if (!('IntersectionObserver' in window)) return;
    var videos = document.querySelectorAll('video[data-autoplay-in-view]');
    if (!videos.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          v.currentTime = 0;
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '-50px' });
    videos.forEach(function (v) { obs.observe(v); });
  }

  // ---------- DIRECT CHECKOUT (for Pricing CTAs that go straight to checkout) ----------
  function initDirectCheckout() {
    document.querySelectorAll('[data-direct-checkout]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var label = btn.querySelector('.btn-label');
        var loading = btn.querySelector('.btn-loading');
        btn.disabled = true;
        if (label) label.style.display = 'none';
        if (loading) loading.style.display = '';
        var hasDiscount = localStorage.getItem('newsletter_discount') === 'true';
        var discountCode = hasDiscount ? (CFG.discountCode || 'WELCOME10') : null;
        createShopifyCart([
          { variantId: CFG.blueprintVariantId, quantity: 1 }
        ], discountCode).then(function (r) {
          if (r && r.checkoutUrl) goToCheckout(r.checkoutUrl);
          else {
            btn.disabled = false;
            if (label) label.style.display = '';
            if (loading) loading.style.display = 'none';
            toast('Error creating checkout. Please try again.', null, 'destructive');
          }
        }).catch(function (err) {
          btn.disabled = false;
          if (label) label.style.display = '';
          if (loading) loading.style.display = 'none';
          console.error(err);
          toast('Error creating checkout. Please try again.', null, 'destructive');
        });
      });
    });
  }

  // ---------- INIT ALL ----------
  function init() {
    bindDialogs();
    initNewsletter();
    initUpsellPopup();
    initPostPurchase();
    initUpsellPage();
    initFaq();
    initScrollFx();
    initVideos();
    initDirectCheckout();
    document.querySelectorAll('canvas[data-neural]').forEach(initNeuralNetwork);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
